<template>
  <div>
    <LHeaderGallery>
      <LNav />
    </LHeaderGallery>
    <section class="section slider pb-32" id="slider">
      <div class="container">
        <div class="text">Галерея</div>
        <div class="b-t-left b-t-right b-t-bottom b-t-top"></div>
        <div class="row">
          <div class="col-12">
            <Swiper :slides-per-view="1" :space-between="60" :pagination="{ clickable: true }" :navigation="true"
              :modules="[Pagination, Navigation]" autoplay="true" autoplay-delay="2500" loop="true" class="h-full">
              <SwiperSlide v-for="(slide, index) in slides" :key="index" :class="`slide--${index}`" class="h-full">
                <!-- Avoid re-processing every slide on each Swiper DOM mutation. -->
                <img :src="slide" :alt="`Gallery image ${index + 1}`" :loading="index === 0 ? 'eager' : 'lazy'"
                  :fetchpriority="index === 0 ? 'high' : 'auto'" decoding="async" class="h-full object-cover" />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div class="borders b-d-left b-d-right b-d-bottom b-d-top"></div>
      </div>
    </section>
    <LFooter />
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Navigation } from 'swiper/modules'

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Computed properties
const slides = computed(() => {
  const paths = []
  for (let i = 0; i <= 31; i++) {
    paths.push(`https://leonhotel.ru/photos/${i}.jpg`)
  }
  return paths
})

useHead({
  title: 'Галерея - Фотографии и моменты',
  meta: [
    {
      name: 'description',
      content: 'Просмотрите нашу галерею фотографий, запечатлевших самые яркие и незабываемые моменты. Профессиональные фотографии высокого качества.'
    },
    {
      name: 'keywords',
      content: 'галерея, фотографии, фотогалерея, фото, изображения, моменты'
    },
    {
      property: 'og:title',
      content: 'Галерея - Фотографии и моменты'
    },
    {
      property: 'og:description', 
      content: 'Просмотрите нашу галерею фотографий, запечатлевших самые яркие и незабываемые моменты. Профессиональные фотографии высокого качества.'
    },
    {
      property: 'og:type',
      content: 'website'
    }
  ]
})

definePageMeta({
  layout: 'default'
})
</script>

<style lang="scss" scoped>
// Border styles
.b-t-top {
  margin: 0 45px 15px;
  z-index: 1;
  border-top: 2px solid #d9ccaf !important;
}

.b-t-left {
  border-left: 2px solid #d9ccaf !important;
  height: 26px;
}

.b-t-right {
  border-right: 2px solid #d9ccaf !important;
  height: 26px;
}

.b-d-left {
  border-left: 2px solid #d9ccaf !important;
  height: 26px;
}

.b-d-right {
  border-right: 2px solid #d9ccaf !important;
  height: 26px;
}

.b-d-bottom {
  margin: 15px 45px 0;
  border-bottom: 2px solid #d9ccaf !important;
}

.text {
  position: relative;
  width: 200px;
  height: auto;
  background: white;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 40px;
  text-align: center;
  line-height: 92px;
  font-weight: normal;
  font-family: "playfair";
  letter-spacing: 0px;
  color: black;
  padding: 0 16px;
  margin-bottom: -44px;
}

.section {
  margin-top: 30px;
}

@media screen and (max-width: 1000px) {
  .text {
    font-size: 32px;
    line-height: 72px;
    margin-bottom: -33px;
    width: 170px;
  }
}

@media screen and (max-width: 425px) {
  .text {
    font-size: 28px;
    line-height: 62px;
    margin-bottom: -30px;
    width: 140px;
  }
}
</style>

<style>
.agile__list {
  height: 100%;
}

.agile__track {
  height: 100%;
}

.slider .slide.agile__slide {
  height: 100%;
}
</style>
